import { useMemo } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getSelectedCtiContactByNumberFromIntegration } from 'flow/selectors/cti-integration-selectors';
import { ExtensionVoiceMessage } from 'flow/types/VoiceMessage';
import { TypedMap } from 'flow/types/TypedMap';

export const useVoicemailWithCtiContact = (
    voiceMessage: TypedMap<ExtensionVoiceMessage> | undefined,
): TypedMap<ExtensionVoiceMessage> | undefined => {
    const number = voiceMessage?.getIn(['phoneNumber', 'number']);

    const integrationContact = useAppSelector((state) =>
        number
            ? getSelectedCtiContactByNumberFromIntegration(
                  state.integration,
                  number,
              )
            : undefined,
    );

    return useMemo(() => {
        if (
            !voiceMessage ||
            !integrationContact ||
            integrationContact.isEmpty()
        ) {
            return voiceMessage;
        }
        return voiceMessage.set('contact', integrationContact);
    }, [voiceMessage, integrationContact]);
};
